import type { DayAvailability, Period } from "../types/provider-registration";

export function calculateAge(dateStr: string): number | undefined {
	if (!dateStr) return undefined;
	const [yearRaw, monthRaw, dayRaw] = dateStr.split("-");
	const year = Number(yearRaw);
	const month = Number(monthRaw);
	const day = Number(dayRaw);
	if (!year || !month || !day) return undefined;
	const dob = new Date(year, month - 1, day);
	if (Number.isNaN(dob.getTime())) return undefined;
	const today = new Date();
	let age = today.getFullYear() - dob.getFullYear();
	const m = today.getMonth() - dob.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age -= 1;
	return age >= 0 && age < 130 ? age : undefined;
}

export function formatDateInput(date: Date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}

export function parseTime12(value: string): { hour: number; minute: number } | null {
	const trimmed = value.trim();
	const match = /^(0?[1-9]|1[0-2]):([0-5]\d)$/.exec(trimmed);
	if (!match) return null;
	const hour = Number(match[1]);
	const minute = Number(match[2]);
	if (!Number.isFinite(hour) || !Number.isFinite(minute)) return null;
	return { hour, minute };
}

export function normalizeTime12Input(value: string): string {
	const raw = value.trim();
	if (!raw) return "";
	const match = /^(\d{1,2})(?::(\d{0,2}))?$/.exec(raw);
	if (!match) return value;
	const hourRaw = match[1];
	const minuteRaw = match[2] ?? "";
	if (!hourRaw) return value;
	let hour = hourRaw.replace(/^0+/, "");
	if (!hour) hour = "0";
	const minute = (minuteRaw || "0").padEnd(2, "0").slice(0, 2);
	return `${hour}:${minute}`;
}

export function time12ToMinutes(value: string, period: Period): number | null {
	const parsed = parseTime12(value);
	if (!parsed) return null;
	const h = parsed.hour % 12;
	const hour24 = period === "PM" ? h + 12 : h;
	return hour24 * 60 + parsed.minute;
}

export function createDefaultAvailability(): DayAvailability[] {
	return [
		{ day: "Lunes", enabled: true, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
		{ day: "Martes", enabled: true, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
		{ day: "Miércoles", enabled: true, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
		{ day: "Jueves", enabled: true, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
		{ day: "Viernes", enabled: true, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
		{ day: "Sábado", enabled: false, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
		{ day: "Domingo", enabled: false, startTime: "09:00", startPeriod: "AM", endTime: "06:00", endPeriod: "PM" },
	];
}
